import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import 'babel-polyfill';

// Load SCSS
import '../scss/base/_font-faces.scss';
import '../scss/app.scss';

// Import React-Base
import Router from './Base/Router';
import Store from './Base/Store';
import i18n from './Base/i18n'; // initialized i18next instance

ReactDOM.render(
  <I18nextProvider i18n={i18n}>
    <Provider store={Store}>
      {Router}
    </Provider>
  </I18nextProvider>
  ,
  document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./frontend/js/index.jsx